export function getView(event_type, appointment_status) {
  return (
    event_type === 'appointment_bookings_state_update' &&
    Array.isArray(appointment_status) &&
    appointment_status.length === 1 &&
    appointment_status[0] === 'SCHEDULED'
  )
}
